// extracted by mini-css-extract-plugin
export var cardHeader = "_sr-0";
export var reorderHandle = "_sr-3";
export var titleArea = "_sr-1";
export var titleAreaWithHandle = "_sr-2";